<!--
  Vue wrapper for Bryntum SchedulerBase
-->

<template>
    <div>
        <!-- Container for Vue components used in cells, hidden from view -->
        <div
            ref   = "cellInstancesHolder"
            style = "display: none"
        >
            <component
                :is    = "component.is"
                v-for  = "component in cellInstances"
                :ref   = "component.key"
                :key   = "component.key"
                v-bind = "component"
            />
        </div>
    </div>
</template>

<script>

import { AjaxStore, Base, Column, ColumnStore, Container, CrudManager, DependencyBaseModel, DomClassList, Editor, EventEdit, Field, Grid, GridBase, GridLocation, Mask, Menu, MenuItem, Model, Panel, Popup, PresetStore, ProjectModel, Rectangle, RecurrenceConfirmationPopup, ResourceTimeRangeModel, ResourceTimeRangeStore, ResourceTimeRanges, Row, Scheduler, SchedulerAssignmentModel, SchedulerAssignmentStore, SchedulerBase, SchedulerDependencyEdit, SchedulerDependencyModel, SchedulerDependencyStore, SchedulerEventModel, SchedulerEventStore, SchedulerResourceModel, SchedulerResourceStore, ScrollManager, Scroller, StateProvider, Store, SubGrid, TimeAxis, TimeAxisColumn, TimeSpan, TimelineBase, Tool, TreeSummary, VerticalTimeAxisColumn, ViewPreset, Widget } from '@bryntum/schedulerpro';

import { StringHelper } from '@bryntum/schedulerpro';
import WrapperHelper from './WrapperHelper.js';

export default {

    // eslint-disable-next-line vue/multi-word-component-names
    name : 'BryntumSchedulerBase',

    props : {

        // Configs only
        adopt                            : { type : [HTMLElement, String], default : undefined },
        allowCreate                      : { type : Boolean, default : undefined },
        allowCreateOnlyParent            : { type : Boolean, default : undefined },
        animateFilterRemovals            : { type : Boolean, default : undefined },
        animateRemovingRows              : { type : Boolean, default : undefined },
        animateTreeNodeToggle            : { type : Boolean, default : undefined },
        ariaDescription                  : { type : String, default : undefined },
        ariaLabel                        : { type : String, default : undefined },
        autoAdjustTimeAxis               : { type : Boolean, default : undefined },
        autoHeight                       : { type : Boolean, default : undefined },
        bbar                             : { type : [Array, Object, null], default : undefined },
        bodyCls                          : { type : [String, Object], default : undefined },
        bubbleEvents                     : { type : Object, default : undefined },
        bufferCoef                       : { type : Number, default : undefined },
        bufferThreshold                  : { type : Number, default : undefined },
        callOnFunctions                  : { type : Boolean, default : undefined },
        collapsible                      : { type : [Boolean, Object], default : undefined },
        config                           : { type : Object, default : undefined },
        contentElementCls                : { type : [String, Object], default : undefined },
        contextMenuTriggerEvent          : { type : String, default : undefined },
        createEventOnDblClick            : { type : [Boolean, Object], default : undefined },
        creationTooltip                  : { type : Object, default : undefined },
        crudManagerClass                 : { type : Function, default : undefined },
        defaultRegion                    : { type : String, default : undefined },
        defaultResourceImageName         : { type : String, default : undefined },
        descriptionRenderer              : { type : Function, default : undefined },
        deselectAllOnScheduleClick       : { type : Boolean, default : undefined },
        deselectOnClick                  : { type : Boolean, default : undefined },
        destroyStore                     : { type : Boolean, default : undefined },
        destroyStores                    : { type : Boolean, default : undefined },
        disableGridColumnIdWarning       : { type : Boolean, default : undefined },
        disableGridRowModelWarning       : { type : Boolean, default : undefined },
        dock                             : { type : [String, Object], default : undefined },
        drawer                           : { type : [Boolean, String], default : undefined },
        durationDisplayPrecision         : { type : [Number, Boolean], default : undefined },
        elementAttributes                : { type : Object, default : undefined },
        enableDeleteKey                  : { type : Boolean, default : undefined },
        enableRecurringEvents            : { type : [Boolean, Object], default : undefined },
        enableSticky                     : { type : Boolean, default : undefined },
        enableTextSelection              : { type : Boolean, default : undefined },
        enableTransactionalFeatures      : { type : Boolean, default : undefined },
        endParamName                     : { type : String, default : undefined },
        eventBarTextField                : { type : String, default : undefined },
        eventRenderer                    : { type : Function, default : undefined },
        eventRendererThisObj             : { type : Object, default : undefined },
        eventSelectionDisabled           : { type : Boolean, default : undefined },
        fillLastColumn                   : { type : Boolean, default : undefined },
        fixedRowHeight                   : { type : Boolean, default : undefined },
        footer                           : { type : [Object, String], default : undefined },
        formulaProviders                 : { type : Object, default : undefined },
        fullRowRefresh                   : { type : Boolean, default : undefined },
        getDateConstraints               : { type : Function, default : undefined },
        getRowHeight                     : { type : Function, default : undefined },
        header                           : { type : [String, Boolean, Object], default : undefined },
        hideHorizontalScrollbar          : { type : Boolean, default : undefined },
        highlightPredecessors            : { type : Boolean, default : undefined },
        highlightSuccessors              : { type : Boolean, default : undefined },
        hoverCls                         : { type : String, default : undefined },
        ignoreDomEventsWhileScrolling    : { type : Boolean, default : undefined },
        ignoreParentReadOnly             : { type : Boolean, default : undefined },
        listeners                        : { type : Object, default : undefined },
        listRangeMenu                    : { type : Object, default : undefined },
        loadMask                         : { type : [String, Object, null], default : undefined },
        loadMaskDefaults                 : { type : Object, default : undefined },
        loadMaskError                    : { type : [Object, Mask, Boolean], default : undefined },
        localizable                      : { type : Boolean, default : undefined },
        maintainSelectionOnDatasetChange : { type : Boolean, default : undefined },
        managedEventSizing               : { type : Boolean, default : undefined },
        maskDefaults                     : { type : Object, default : undefined },
        masked                           : { type : [Boolean, String, Object], default : undefined },
        maxDate                          : { type : [Date, String], default : undefined },
        maxTimeAxisUnit                  : { type : String, default : undefined },
        minDate                          : { type : [Date, String], default : undefined },
        mode                             : { type : String, default : undefined },
        monitorResize                    : { type : Boolean, default : undefined },
        multiEventSelect                 : { type : Boolean, default : undefined },
        narrowEventWidth                 : { type : Number, default : undefined },
        owner                            : { type : Widget, default : undefined },
        partner                          : { type : TimelineBase, default : undefined },
        passStartEndParameters           : { type : Boolean, default : undefined },
        plugins                          : { type : Array, default : undefined },
        preCalculateHeightLimit          : { type : Number, default : undefined },
        preserveFocusOnDatasetChange     : { type : Boolean, default : undefined },
        preserveScrollOnDatasetChange    : { type : Boolean, default : undefined },
        preventTooltipOnTouch            : { type : Boolean, default : undefined },
        relayStoreEvents                 : { type : Boolean, default : undefined },
        resizable                        : { type : [Boolean, Object], default : undefined },
        resizeToFitIncludesHeader        : { type : Boolean, default : undefined },
        resourceColumns                  : { type : Object, default : undefined },
        resourceImageExtension           : { type : String, default : undefined },
        resourceImagePath                : { type : String, default : undefined },
        resourceTimeRangeRenderer        : { type : Function, default : undefined },
        responsiveLevels                 : { type : Object, default : undefined },
        ripple                           : { type : [Boolean, Object], default : undefined },
        rootElement                      : { type : [ShadowRoot, HTMLElement], default : undefined },
        scrollerClass                    : { type : Function, default : undefined },
        scrollExtensionThreshold         : { type : [String, Object], default : undefined },
        scrollManager                    : { type : [Object, ScrollManager], default : undefined },
        showCreationTooltip              : { type : Boolean, default : undefined },
        showDirty                        : { type : [Boolean, Object], default : undefined },
        showEventColorPickers            : { type : Boolean, default : undefined },
        showLagInTooltip                 : { type : Boolean, default : undefined },
        showRecurringUI                  : { type : Boolean, default : undefined },
        snapRelativeToEventStartDate     : { type : Boolean, default : undefined },
        startParamName                   : { type : String, default : undefined },
        stateful                         : { type : [Boolean, Object, Array], default : undefined },
        statefulEvents                   : { type : [Object, Array], default : undefined },
        stateId                          : { type : String, default : undefined },
        stateProvider                    : { type : StateProvider, default : undefined },
        stepUnit                         : { type : String, default : undefined },
        stickyHeaders                    : { type : Boolean, default : undefined },
        strips                           : { type : Object, default : undefined },
        subGridConfigs                   : { type : Object, default : undefined },
        syncMask                         : { type : [String, Object, null], default : undefined },
        tab                              : { type : [Boolean, Object], default : undefined },
        tabBarItems                      : { type : Array, default : undefined },
        tbar                             : { type : [Array, Object, null], default : undefined },
        terminalCls                      : { type : String, default : undefined },
        terminalSides                    : { type : Array, default : undefined },
        timeAxis                         : { type : [Object, TimeAxis], default : undefined },
        triggerSelectionChangeOnRemove   : { type : Boolean, default : undefined },
        ui                               : { type : [String, Object], default : undefined },
        verticalTimeAxisColumn           : { type : Object, default : undefined },
        visibleZoomFactor                : { type : Number, default : undefined },
        weekStartDay                     : { type : Number, default : undefined },
        weight                           : { type : Number, default : undefined },
        zoomKeepsOriginalTimespan        : { type : Boolean, default : undefined },
        zoomOnMouseWheel                 : { type : Boolean, default : undefined },
        zoomOnTimeAxisDoubleClick        : { type : Boolean, default : undefined },

        // Configs and properties
        alignSelf                     : { type : String, default : undefined },
        allowDropOnEventBar           : { type : Boolean, default : undefined },
        allowOverlap                  : { type : Boolean, default : undefined },
        appendTo                      : { type : [HTMLElement, String], default : undefined },
        ariaLive                      : { type : String, default : undefined },
        assignments                   : { type : Array, default : undefined },
        assignmentStore               : { type : [SchedulerAssignmentStore, Object], default : undefined },
        autoCreate                    : { type : [Boolean, String], default : undefined },
        barMargin                     : { type : Number, default : undefined },
        cellEllipsis                  : { type : Boolean, default : undefined },
        cls                           : { type : [String, Object], default : undefined },
        collapsed                     : { type : Boolean, default : undefined },
        columnLines                   : { type : Boolean, default : undefined },
        columns                       : { type : [ColumnStore, Array, Object], default : undefined },
        creationTooltipTemplate       : { type : Function, default : undefined },
        crudManager                   : { type : [CrudManager, Object], default : undefined },
        data                          : { type : Array, default : undefined },
        dataset                       : { type : Object, default : undefined },
        date                          : { type : Date, default : undefined },
        dateFormat                    : { type : String, default : undefined },
        dateSeparator                 : { type : String, default : undefined },
        dependencies                  : { type : Array, default : undefined },
        dependencyStore               : { type : [SchedulerDependencyStore, Object], default : undefined },
        descriptionFormat             : { type : [String, Array], default : undefined },
        disabled                      : { type : [Boolean, String], default : undefined },
        displayDateFormat             : { type : String, default : undefined },
        emptyText                     : { type : [String, Object], default : undefined },
        enableEventAnimations         : { type : Boolean, default : undefined },
        enableUndoRedoKeys            : { type : Boolean, default : undefined },
        endDate                       : { type : [Date, String], default : undefined },
        eventColor                    : { type : [String, null], default : undefined },
        eventLayout                   : { type : [String, Object], default : undefined },
        eventReleaseThreshold         : { type : Number, default : undefined },
        events                        : { type : Array, default : undefined },
        eventStore                    : { type : [SchedulerEventStore, Object], default : undefined },
        eventStyle                    : { type : [String, null], default : undefined },
        extraData                     : { type : Object, default : undefined },
        fillTicks                     : { type : Boolean, default : undefined },
        flex                          : { type : [Number, String], default : undefined },
        forceFit                      : { type : Boolean, default : undefined },
        height                        : { type : [Number, String], default : undefined },
        hidden                        : { type : Boolean, default : undefined },
        hideFooters                   : { type : Boolean, default : undefined },
        hideHeaders                   : { type : Boolean, default : undefined },
        hideRowHover                  : { type : Boolean, default : undefined },
        id                            : { type : String, default : undefined },
        infiniteScroll                : { type : Boolean, default : undefined },
        insertBefore                  : { type : [HTMLElement, String], default : undefined },
        insertFirst                   : { type : [HTMLElement, String], default : undefined },
        isEventSelectable             : { type : Function, default : undefined },
        keyMap                        : { type : Object, default : undefined },
        longPressTime                 : { type : Number, default : undefined },
        margin                        : { type : [Number, String], default : undefined },
        maxHeight                     : { type : [String, Number], default : undefined },
        maxWidth                      : { type : [String, Number], default : undefined },
        maxZoomLevel                  : { type : Number, default : undefined },
        milestoneAlign                : { type : String, default : undefined },
        milestoneCharWidth            : { type : Number, default : undefined },
        milestoneLayoutMode           : { type : String, default : undefined },
        milestoneTextPosition         : { type : String, default : undefined },
        minHeight                     : { type : [String, Number], default : undefined },
        minWidth                      : { type : [String, Number], default : undefined },
        minZoomLevel                  : { type : Number, default : undefined },
        overlappingEventSorter        : { type : Function, default : undefined },
        preserveScroll                : { type : [Object, Boolean], default : undefined },
        presets                       : { type : [PresetStore, Array], default : undefined },
        project                       : { type : [ProjectModel, Object], default : undefined },
        range                         : { type : [String, Object], default : undefined },
        readOnly                      : { type : Boolean, default : undefined },
        recurrenceConfirmationPopup   : { type : [Object, RecurrenceConfirmationPopup], default : undefined },
        resourceMargin                : { type : [Number, Object], default : undefined },
        resources                     : { type : Array, default : undefined },
        resourceStore                 : { type : [SchedulerResourceStore, Object], default : undefined },
        resourceTimeRanges            : { type : Array, default : undefined },
        resourceTimeRangeStore        : { type : [ResourceTimeRangeStore, Object], default : undefined },
        rowHeight                     : { type : Number, default : undefined },
        rowLines                      : { type : Boolean, default : undefined },
        rtl                           : { type : Boolean, default : undefined },
        scrollable                    : { type : [Scroller, Boolean, Object], default : undefined },
        selectionMode                 : { type : Object, default : undefined },
        selectResourceOnEventNavigate : { type : Boolean, default : undefined },
        selectResourceOnScheduleClick : { type : Boolean, default : undefined },
        shiftIncrement                : { type : [String, Object], default : undefined },
        showTooltip                   : { type : Boolean, default : undefined },
        snap                          : { type : Boolean, default : undefined },
        startDate                     : { type : [Date, String], default : undefined },
        stateSettings                 : { type : Object, default : undefined },
        store                         : { type : [Store, Object, AjaxStore], default : undefined },
        suppressFit                   : { type : Boolean, default : undefined },
        terminalHideDelay             : { type : Number, default : undefined },
        terminalOffset                : { type : Number, default : undefined },
        terminalShowDelay             : { type : Number, default : undefined },
        terminalSize                  : { type : [Number, String], default : undefined },
        tickSize                      : { type : Number, default : undefined },
        timeRanges                    : { type : Array, default : undefined },
        timeRangeStore                : { type : [Store, Object], default : undefined },
        timeResolution                : { type : [Object, Number], default : undefined },
        timeZone                      : { type : [String, Number], default : undefined },
        title                         : { type : String, default : undefined },
        tools                         : { type : [Object, null], default : undefined },
        tooltipTemplate               : { type : Function, default : undefined },
        transitionDuration            : { type : Number, default : undefined },
        updateTimelineContextOnScroll : { type : Boolean, default : undefined },
        useContextualRecurrenceRules  : { type : Boolean, default : undefined },
        useInitialAnimation           : { type : [Boolean, String], default : undefined },
        viewPreset                    : { type : [ViewPreset, Object, String], default : undefined },
        visibleDate                   : { type : [Object, Date], default : undefined },
        width                         : { type : [Number, String], default : undefined },
        workingTime                   : { type : Object, default : undefined },

        // Properties only
        focusVisible        : { type : Boolean, default : undefined },
        hasChanges          : { type : Boolean, default : undefined },
        isEngineReady       : { type : Boolean, default : undefined },
        originalStore       : { type : Store, default : undefined },
        parent              : { type : Widget, default : undefined },
        scrollLeft          : { type : Number, default : undefined },
        scrollTop           : { type : Number, default : undefined },
        scrollX             : { type : Number, default : undefined },
        selectedAssignments : { type : Array, default : undefined },
        selectedCell        : { type : [GridLocation, Object], default : undefined },
        selectedCells       : { type : Array, default : undefined },
        selectedEvents      : { type : Array, default : undefined },
        selectedRecord      : { type : Model, default : undefined },
        selectedRecords     : { type : Array, default : undefined },
        selectedRows        : { type : Array, default : undefined },
        state               : { type : Object, default : undefined },
        tooltip             : { type : [String, Object], default : undefined },
        zoomLevel           : { type : Number, default : undefined },

        // Events
        onAfterDependencyCreateDrop       : { type : Function },
        onAfterDependencySave             : { type : Function },
        onAfterDragCreate                 : { type : Function },
        onAfterEventDragSelect            : { type : Function },
        onAfterEventDrop                  : { type : Function },
        onAfterEventEdit                  : { type : Function },
        onAfterEventSave                  : { type : Function },
        onAssignmentSelectionChange       : { type : Function },
        onBeforeAssignmentDelete          : { type : Function },
        onBeforeAssignmentSelectionChange : { type : Function },
        onBeforeAutoCreate                : { type : Function },
        onBeforeCancelCellEdit            : { type : Function },
        onBeforeCancelRowEdit             : { type : Function },
        onBeforeCellDelete                : { type : Function },
        onBeforeCellEditStart             : { type : Function },
        onBeforeColumnDragStart           : { type : Function },
        onBeforeColumnDropFinalize        : { type : Function },
        onBeforeColumnResize              : { type : Function },
        onBeforeCopy                      : { type : Function },
        onBeforeCSVExport                 : { type : Function },
        onBeforeDependencyAdd             : { type : Function },
        onBeforeDependencyCreateDrag      : { type : Function },
        onBeforeDependencyCreateFinalize  : { type : Function },
        onBeforeDependencyDelete          : { type : Function },
        onBeforeDependencyEdit            : { type : Function },
        onBeforeDependencyEditShow        : { type : Function },
        onBeforeDependencySave            : { type : Function },
        onBeforeDestroy                   : { type : Function },
        onBeforeDragCreate                : { type : Function },
        onBeforeDragCreateFinalize        : { type : Function },
        onBeforeEventAdd                  : { type : Function },
        onBeforeEventDelete               : { type : Function },
        onBeforeEventDrag                 : { type : Function },
        onBeforeEventDragSelect           : { type : Function },
        onBeforeEventDropFinalize         : { type : Function },
        onBeforeEventEdit                 : { type : Function },
        onBeforeEventEditShow             : { type : Function },
        onBeforeEventResize               : { type : Function },
        onBeforeEventResizeFinalize       : { type : Function },
        onBeforeEventSave                 : { type : Function },
        onBeforeEventSelectionChange      : { type : Function },
        onBeforeExcelExport               : { type : Function },
        onBeforeFillHandleDragStart       : { type : Function },
        onBeforeFinishCellEdit            : { type : Function },
        onBeforeFinishRowEdit             : { type : Function },
        onBeforeHide                      : { type : Function },
        onBeforePan                       : { type : Function },
        onBeforePaste                     : { type : Function },
        onBeforePdfExport                 : { type : Function },
        onBeforePresetChange              : { type : Function },
        onBeforeRenderRow                 : { type : Function },
        onBeforeRenderRows                : { type : Function },
        onBeforeRowCollapse               : { type : Function },
        onBeforeRowExpand                 : { type : Function },
        onBeforeSelectionChange           : { type : Function },
        onBeforeSetRecord                 : { type : Function },
        onBeforeShow                      : { type : Function },
        onBeforeShowTerminals             : { type : Function },
        onBeforeStartRowEdit              : { type : Function },
        onBeforeStateApply                : { type : Function },
        onBeforeStateSave                 : { type : Function },
        onBeforeToggleGroup               : { type : Function },
        onBeforeToggleNode                : { type : Function },
        onCancelCellEdit                  : { type : Function },
        onCatchAll                        : { type : Function },
        onCellClick                       : { type : Function },
        onCellContextMenu                 : { type : Function },
        onCellDblClick                    : { type : Function },
        onCellMenuBeforeShow              : { type : Function },
        onCellMenuItem                    : { type : Function },
        onCellMenuShow                    : { type : Function },
        onCellMenuToggleItem              : { type : Function },
        onCellMouseEnter                  : { type : Function },
        onCellMouseLeave                  : { type : Function },
        onCellMouseOut                    : { type : Function },
        onCellMouseOver                   : { type : Function },
        onCollapse                        : { type : Function },
        onCollapseNode                    : { type : Function },
        onColumnDrag                      : { type : Function },
        onColumnDragStart                 : { type : Function },
        onColumnDrop                      : { type : Function },
        onColumnResize                    : { type : Function },
        onColumnResizeStart               : { type : Function },
        onContextMenuItem                 : { type : Function },
        onContextMenuToggleItem           : { type : Function },
        onCopy                            : { type : Function },
        onCurrentTimelineUpdate           : { type : Function },
        onDataChange                      : { type : Function },
        onDateRangeChange                 : { type : Function },
        onDependenciesDrawn               : { type : Function },
        onDependencyClick                 : { type : Function },
        onDependencyContextMenu           : { type : Function },
        onDependencyCreateDragStart       : { type : Function },
        onDependencyCreateDrop            : { type : Function },
        onDependencyDblClick              : { type : Function },
        onDependencyMenuBeforeShow        : { type : Function },
        onDependencyMenuItem              : { type : Function },
        onDependencyMenuShow              : { type : Function },
        onDependencyMouseOut              : { type : Function },
        onDependencyMouseOver             : { type : Function },
        onDependencyValidationComplete    : { type : Function },
        onDependencyValidationStart       : { type : Function },
        onDestroy                         : { type : Function },
        onDirtyStateChange                : { type : Function },
        onDragCreateEnd                   : { type : Function },
        onDragCreateStart                 : { type : Function },
        onDragSelecting                   : { type : Function },
        onEventAutoCreated                : { type : Function },
        onEventClick                      : { type : Function },
        onEventContextMenu                : { type : Function },
        onEventDblClick                   : { type : Function },
        onEventDrag                       : { type : Function },
        onEventDragAbort                  : { type : Function },
        onEventDragModeChange             : { type : Function },
        onEventDragReset                  : { type : Function },
        onEventDragSelect                 : { type : Function },
        onEventDragStart                  : { type : Function },
        onEventDrop                       : { type : Function },
        onEventEditBeforeSetRecord        : { type : Function },
        onEventKeyDown                    : { type : Function },
        onEventKeyUp                      : { type : Function },
        onEventMenuBeforeShow             : { type : Function },
        onEventMenuItem                   : { type : Function },
        onEventMenuShow                   : { type : Function },
        onEventMouseDown                  : { type : Function },
        onEventMouseEnter                 : { type : Function },
        onEventMouseLeave                 : { type : Function },
        onEventMouseOut                   : { type : Function },
        onEventMouseOver                  : { type : Function },
        onEventMouseUp                    : { type : Function },
        onEventPartialResize              : { type : Function },
        onEventResizeEnd                  : { type : Function },
        onEventResizeStart                : { type : Function },
        onEventSelectionChange            : { type : Function },
        onExpand                          : { type : Function },
        onExpandNode                      : { type : Function },
        onFileDrop                        : { type : Function },
        onFillHandleBeforeDragFinalize    : { type : Function },
        onFillHandleDrag                  : { type : Function },
        onFillHandleDragAbort             : { type : Function },
        onFillHandleDragEnd               : { type : Function },
        onFillHandleDragStart             : { type : Function },
        onFinishCellEdit                  : { type : Function },
        onFinishRowEdit                   : { type : Function },
        onFocusIn                         : { type : Function },
        onFocusOut                        : { type : Function },
        onGridRowBeforeDragStart          : { type : Function },
        onGridRowBeforeDropFinalize       : { type : Function },
        onGridRowDrag                     : { type : Function },
        onGridRowDragAbort                : { type : Function },
        onGridRowDragStart                : { type : Function },
        onGridRowDrop                     : { type : Function },
        onHeaderClick                     : { type : Function },
        onHeaderMenuBeforeShow            : { type : Function },
        onHeaderMenuItem                  : { type : Function },
        onHeaderMenuShow                  : { type : Function },
        onHeaderMenuToggleItem            : { type : Function },
        onHide                            : { type : Function },
        onLockRows                        : { type : Function },
        onMouseOut                        : { type : Function },
        onMouseOver                       : { type : Function },
        onNavigate                        : { type : Function },
        onPaint                           : { type : Function },
        onPaste                           : { type : Function },
        onPasteNotAllowed                 : { type : Function },
        onPdfExport                       : { type : Function },
        onPresetChange                    : { type : Function },
        onReadOnly                        : { type : Function },
        onRecompose                       : { type : Function },
        onReleaseEvent                    : { type : Function },
        onRenderEvent                     : { type : Function },
        onRenderRow                       : { type : Function },
        onRenderRows                      : { type : Function },
        onResize                          : { type : Function },
        onResourceHeaderClick             : { type : Function },
        onResourceHeaderContextmenu       : { type : Function },
        onResourceHeaderDblclick          : { type : Function },
        onResourceMenuBeforeShow          : { type : Function },
        onResourceMenuItem                : { type : Function },
        onResourceMenuShow                : { type : Function },
        onResourceMenuToggleItem          : { type : Function },
        onResourceTimeRangeClick          : { type : Function },
        onResourceTimeRangeContextMenu    : { type : Function },
        onResourceTimeRangeDblClick       : { type : Function },
        onResourceTimeRangeMouseDown      : { type : Function },
        onResourceTimeRangeMouseOut       : { type : Function },
        onResourceTimeRangeMouseOver      : { type : Function },
        onResourceTimeRangeMouseUp        : { type : Function },
        onResponsive                      : { type : Function },
        onRowCollapse                     : { type : Function },
        onRowExpand                       : { type : Function },
        onRowMouseEnter                   : { type : Function },
        onRowMouseLeave                   : { type : Function },
        onScheduleClick                   : { type : Function },
        onScheduleContextMenu             : { type : Function },
        onScheduleDblClick                : { type : Function },
        onScheduleMenuBeforeShow          : { type : Function },
        onScheduleMenuItem                : { type : Function },
        onScheduleMenuShow                : { type : Function },
        onScheduleMouseDown               : { type : Function },
        onScheduleMouseEnter              : { type : Function },
        onScheduleMouseLeave              : { type : Function },
        onScheduleMouseMove               : { type : Function },
        onScheduleMouseUp                 : { type : Function },
        onScroll                          : { type : Function },
        onScrollButtonClick               : { type : Function },
        onSelectionChange                 : { type : Function },
        onSelectionModeChange             : { type : Function },
        onShiftIncrementChange            : { type : Function },
        onShow                            : { type : Function },
        onSplit                           : { type : Function },
        onSplitterCollapseClick           : { type : Function },
        onSplitterDragEnd                 : { type : Function },
        onSplitterDragStart               : { type : Function },
        onSplitterExpandClick             : { type : Function },
        onStartCellEdit                   : { type : Function },
        onStartRowEdit                    : { type : Function },
        onSubGridCollapse                 : { type : Function },
        onSubGridExpand                   : { type : Function },
        onTickCellClick                   : { type : Function },
        onTickCellContextMenu             : { type : Function },
        onTickCellDblClick                : { type : Function },
        onTickCellMouseDown               : { type : Function },
        onTickCellMouseUp                 : { type : Function },
        onTickSizeChange                  : { type : Function },
        onTimeAxisChange                  : { type : Function },
        onTimeAxisHeaderClick             : { type : Function },
        onTimeAxisHeaderContextMenu       : { type : Function },
        onTimeAxisHeaderDblClick          : { type : Function },
        onTimeAxisHeaderMenuBeforeShow    : { type : Function },
        onTimeAxisHeaderMenuItem          : { type : Function },
        onTimeAxisHeaderMenuShow          : { type : Function },
        onTimelineContextChange           : { type : Function },
        onTimelineViewportResize          : { type : Function },
        onTimeRangeHeaderClick            : { type : Function },
        onTimeRangeHeaderContextMenu      : { type : Function },
        onTimeRangeHeaderDblClick         : { type : Function },
        onTimeSelectionChange             : { type : Function },
        onTimeSelectionElementClick       : { type : Function },
        onToggleGroup                     : { type : Function },
        onToggleNode                      : { type : Function },
        onToolClick                       : { type : Function },
        onUnlockRows                      : { type : Function },
        onUnsplit                         : { type : Function },
        onVisibleDateRangeChange          : { type : Function },

        // Features
        cellCopyPasteFeature       : { type : [Object, Boolean, String], default : undefined },
        cellEditFeature            : { type : [Object, Boolean, String], default : undefined },
        cellMenuFeature            : { type : [Object, Boolean, String], default : undefined },
        cellTooltipFeature         : { type : [Object, Boolean, String], default : undefined },
        columnAutoWidthFeature     : { type : [Object, Boolean, String], default : undefined },
        columnDragToolbarFeature   : { type : [Object, Boolean, String], default : undefined },
        columnLinesFeature         : { type : [Object, Boolean, String], default : undefined },
        columnPickerFeature        : { type : [Object, Boolean, String], default : undefined },
        columnRenameFeature        : { type : [Object, Boolean, String], default : undefined },
        columnReorderFeature       : { type : [Object, Boolean, String], default : undefined },
        columnResizeFeature        : { type : [Object, Boolean, String], default : undefined },
        dependenciesFeature        : { type : [Object, Boolean, String], default : undefined },
        dependencyEditFeature      : { type : [Object, Boolean, String], default : undefined },
        dependencyMenuFeature      : { type : [Object, Boolean, String], default : undefined },
        eventCopyPasteFeature      : { type : [Object, Boolean, String], default : undefined },
        eventDragFeature           : { type : [Object, Boolean, String], default : undefined },
        eventDragCreateFeature     : { type : [Object, Boolean, String], default : undefined },
        eventDragSelectFeature     : { type : [Object, Boolean, String], default : undefined },
        eventEditFeature           : { type : [Object, Boolean, String], default : undefined },
        eventFilterFeature         : { type : [Object, Boolean, String], default : undefined },
        eventMenuFeature           : { type : [Object, Boolean, String], default : undefined },
        eventNonWorkingTimeFeature : { type : [Object, Boolean, String], default : undefined },
        eventResizeFeature         : { type : [Object, Boolean, String], default : undefined },
        eventTooltipFeature        : { type : [Object, Boolean, String], default : undefined },
        excelExporterFeature       : { type : [Object, Boolean, String], default : undefined },
        fileDropFeature            : { type : [Object, Boolean, String], default : undefined },
        fillHandleFeature          : { type : [Object, Boolean, String], default : undefined },
        filterFeature              : { type : [Object, Boolean, String], default : undefined },
        filterBarFeature           : { type : [Object, Boolean, String], default : undefined },
        groupFeature               : { type : [Object, Boolean, String], default : undefined },
        groupSummaryFeature        : { type : [Object, Boolean, String], default : undefined },
        headerMenuFeature          : { type : [Object, Boolean, String], default : undefined },
        headerZoomFeature          : { type : [Object, Boolean, String], default : undefined },
        labelsFeature              : { type : [Object, Boolean, String], default : undefined },
        lockRowsFeature            : { type : [Object, Boolean, String], default : undefined },
        mergeCellsFeature          : { type : [Object, Boolean, String], default : undefined },
        nonWorkingTimeFeature      : { type : [Object, Boolean, String], default : undefined },
        panFeature                 : { type : [Object, Boolean, String], default : undefined },
        pdfExportFeature           : { type : [Object, Boolean, String], default : undefined },
        printFeature               : { type : [Object, Boolean, String], default : undefined },
        quickFindFeature           : { type : [Object, Boolean, String], default : undefined },
        regionResizeFeature        : { type : [Object, Boolean, String], default : undefined },
        resourceMenuFeature        : { type : [Object, Boolean, String], default : undefined },
        resourceTimeRangesFeature  : { type : [Object, Boolean, String], default : undefined },
        rowCopyPasteFeature        : { type : [Object, Boolean, String], default : undefined },
        rowEditFeature             : { type : [Object, Boolean, String], default : undefined },
        rowExpanderFeature         : { type : [Object, Boolean, String], default : undefined },
        rowReorderFeature          : { type : [Object, Boolean, String], default : undefined },
        rowResizeFeature           : { type : [Object, Boolean, String], default : undefined },
        scheduleContextFeature     : { type : [Object, Boolean, String], default : undefined },
        scheduleMenuFeature        : { type : [Object, Boolean, String], default : undefined },
        scheduleTooltipFeature     : { type : [Object, Boolean, String], default : undefined },
        scrollButtonsFeature       : { type : [Object, Boolean, String], default : undefined },
        searchFeature              : { type : [Object, Boolean, String], default : undefined },
        simpleEventEditFeature     : { type : [Object, Boolean, String], default : undefined },
        sortFeature                : { type : [Object, Boolean, String], default : undefined },
        splitFeature               : { type : [Object, Boolean, String], default : undefined },
        stickyCellsFeature         : { type : [Object, Boolean, String], default : undefined },
        stickyEventsFeature        : { type : [Object, Boolean, String], default : undefined },
        stripeFeature              : { type : [Object, Boolean, String], default : undefined },
        summaryFeature             : { type : [Object, Boolean, String], default : undefined },
        timeAxisHeaderMenuFeature  : { type : [Object, Boolean, String], default : undefined },
        timeRangesFeature          : { type : [Object, Boolean, String], default : undefined },
        timeSelectionFeature       : { type : [Object, Boolean, String], default : undefined },
        treeFeature                : { type : [Object, Boolean, String], default : undefined },
        treeGroupFeature           : { type : [Object, Boolean, String], default : undefined },
        treeSummaryFeature         : { type : [Object, Boolean, String], default : undefined },

    },

    data : () => {
        return {
            instanceClass : SchedulerBase,
            instanceName : 'SchedulerBase',

            isView : true,

            cellInstances : [],

            dataStores : {
                'assignmentStore': 'assignments',
                'dependencyStore': 'dependencies',
                'eventStore': 'events',
                'originalStore': 'originals',
                'resourceStore': 'resources',
                'resourceTimeRangeStore': 'resourceTimeRanges',
                'timeRangeStore': 'timeRanges'
            },

            projectStores : false,

            featureNames : [
                'cellCopyPasteFeature',
                'cellEditFeature',
                'cellMenuFeature',
                'cellTooltipFeature',
                'columnAutoWidthFeature',
                'columnDragToolbarFeature',
                'columnLinesFeature',
                'columnPickerFeature',
                'columnRenameFeature',
                'columnReorderFeature',
                'columnResizeFeature',
                'dependenciesFeature',
                'dependencyEditFeature',
                'dependencyMenuFeature',
                'eventCopyPasteFeature',
                'eventDragFeature',
                'eventDragCreateFeature',
                'eventDragSelectFeature',
                'eventEditFeature',
                'eventFilterFeature',
                'eventMenuFeature',
                'eventNonWorkingTimeFeature',
                'eventResizeFeature',
                'eventTooltipFeature',
                'excelExporterFeature',
                'fileDropFeature',
                'fillHandleFeature',
                'filterFeature',
                'filterBarFeature',
                'groupFeature',
                'groupSummaryFeature',
                'headerMenuFeature',
                'headerZoomFeature',
                'labelsFeature',
                'lockRowsFeature',
                'mergeCellsFeature',
                'nonWorkingTimeFeature',
                'panFeature',
                'pdfExportFeature',
                'printFeature',
                'quickFindFeature',
                'regionResizeFeature',
                'resourceMenuFeature',
                'resourceTimeRangesFeature',
                'rowCopyPasteFeature',
                'rowEditFeature',
                'rowExpanderFeature',
                'rowReorderFeature',
                'rowResizeFeature',
                'scheduleContextFeature',
                'scheduleMenuFeature',
                'scheduleTooltipFeature',
                'scrollButtonsFeature',
                'searchFeature',
                'simpleEventEditFeature',
                'sortFeature',
                'splitFeature',
                'stickyCellsFeature',
                'stickyEventsFeature',
                'stripeFeature',
                'summaryFeature',
                'timeAxisHeaderMenuFeature',
                'timeRangesFeature',
                'timeSelectionFeature',
                'treeFeature',
                'treeGroupFeature',
                'treeSummaryFeature'
            ],

            configNames : [
                'adopt',
                'allowCreate',
                'allowCreateOnlyParent',
                'animateFilterRemovals',
                'animateRemovingRows',
                'animateTreeNodeToggle',
                'ariaDescription',
                'ariaLabel',
                'autoAdjustTimeAxis',
                'autoHeight',
                'bbar',
                'bodyCls',
                'bubbleEvents',
                'bufferCoef',
                'bufferThreshold',
                'callOnFunctions',
                'collapsible',
                'config',
                'contentElementCls',
                'contextMenuTriggerEvent',
                'createEventOnDblClick',
                'creationTooltip',
                'crudManagerClass',
                'defaultRegion',
                'defaultResourceImageName',
                'descriptionRenderer',
                'deselectAllOnScheduleClick',
                'deselectOnClick',
                'destroyStore',
                'destroyStores',
                'disableGridColumnIdWarning',
                'disableGridRowModelWarning',
                'dock',
                'drawer',
                'durationDisplayPrecision',
                'elementAttributes',
                'enableDeleteKey',
                'enableRecurringEvents',
                'enableSticky',
                'enableTextSelection',
                'enableTransactionalFeatures',
                'endParamName',
                'eventBarTextField',
                'eventRenderer',
                'eventRendererThisObj',
                'eventSelectionDisabled',
                'fillLastColumn',
                'fixedRowHeight',
                'footer',
                'formulaProviders',
                'fullRowRefresh',
                'getDateConstraints',
                'getRowHeight',
                'header',
                'hideHorizontalScrollbar',
                'highlightPredecessors',
                'highlightSuccessors',
                'hoverCls',
                'ignoreDomEventsWhileScrolling',
                'ignoreParentReadOnly',
                'listeners',
                'listRangeMenu',
                'loadMask',
                'loadMaskDefaults',
                'loadMaskError',
                'localizable',
                'maintainSelectionOnDatasetChange',
                'managedEventSizing',
                'maskDefaults',
                'masked',
                'maxDate',
                'maxTimeAxisUnit',
                'minDate',
                'mode',
                'monitorResize',
                'multiEventSelect',
                'narrowEventWidth',
                'owner',
                'partner',
                'passStartEndParameters',
                'plugins',
                'preCalculateHeightLimit',
                'preserveFocusOnDatasetChange',
                'preserveScrollOnDatasetChange',
                'preventTooltipOnTouch',
                'relayStoreEvents',
                'resizable',
                'resizeToFitIncludesHeader',
                'resourceColumns',
                'resourceImageExtension',
                'resourceImagePath',
                'resourceTimeRangeRenderer',
                'responsiveLevels',
                'ripple',
                'rootElement',
                'scrollerClass',
                'scrollExtensionThreshold',
                'scrollManager',
                'showCreationTooltip',
                'showDirty',
                'showEventColorPickers',
                'showLagInTooltip',
                'showRecurringUI',
                'snapRelativeToEventStartDate',
                'startParamName',
                'stateful',
                'statefulEvents',
                'stateId',
                'stateProvider',
                'stepUnit',
                'stickyHeaders',
                'strips',
                'subGridConfigs',
                'syncMask',
                'tab',
                'tabBarItems',
                'tbar',
                'terminalCls',
                'terminalSides',
                'timeAxis',
                'triggerSelectionChangeOnRemove',
                'ui',
                'verticalTimeAxisColumn',
                'visibleZoomFactor',
                'weekStartDay',
                'weight',
                'zoomKeepsOriginalTimespan',
                'zoomOnMouseWheel',
                'zoomOnTimeAxisDoubleClick'
            ],

            propertyConfigNames : [
                'alignSelf',
                'allowDropOnEventBar',
                'allowOverlap',
                'appendTo',
                'ariaLive',
                'assignments',
                'assignmentStore',
                'autoCreate',
                'barMargin',
                'cellEllipsis',
                'cls',
                'collapsed',
                'columnLines',
                'columns',
                'creationTooltipTemplate',
                'crudManager',
                'data',
                'dataset',
                'date',
                'dateFormat',
                'dateSeparator',
                'dependencies',
                'dependencyStore',
                'descriptionFormat',
                'disabled',
                'displayDateFormat',
                'emptyText',
                'enableEventAnimations',
                'enableUndoRedoKeys',
                'endDate',
                'eventColor',
                'eventLayout',
                'eventReleaseThreshold',
                'events',
                'eventStore',
                'eventStyle',
                'extraData',
                'fillTicks',
                'flex',
                'forceFit',
                'height',
                'hidden',
                'hideFooters',
                'hideHeaders',
                'hideRowHover',
                'id',
                'infiniteScroll',
                'insertBefore',
                'insertFirst',
                'isEventSelectable',
                'keyMap',
                'longPressTime',
                'margin',
                'maxHeight',
                'maxWidth',
                'maxZoomLevel',
                'milestoneAlign',
                'milestoneCharWidth',
                'milestoneLayoutMode',
                'milestoneTextPosition',
                'minHeight',
                'minWidth',
                'minZoomLevel',
                'onAfterDependencyCreateDrop',
                'onAfterDependencySave',
                'onAfterDragCreate',
                'onAfterEventDragSelect',
                'onAfterEventDrop',
                'onAfterEventEdit',
                'onAfterEventSave',
                'onAssignmentSelectionChange',
                'onBeforeAssignmentDelete',
                'onBeforeAssignmentSelectionChange',
                'onBeforeAutoCreate',
                'onBeforeCancelCellEdit',
                'onBeforeCancelRowEdit',
                'onBeforeCellDelete',
                'onBeforeCellEditStart',
                'onBeforeColumnDragStart',
                'onBeforeColumnDropFinalize',
                'onBeforeColumnResize',
                'onBeforeCopy',
                'onBeforeCSVExport',
                'onBeforeDependencyAdd',
                'onBeforeDependencyCreateDrag',
                'onBeforeDependencyCreateFinalize',
                'onBeforeDependencyDelete',
                'onBeforeDependencyEdit',
                'onBeforeDependencyEditShow',
                'onBeforeDependencySave',
                'onBeforeDestroy',
                'onBeforeDragCreate',
                'onBeforeDragCreateFinalize',
                'onBeforeEventAdd',
                'onBeforeEventDelete',
                'onBeforeEventDrag',
                'onBeforeEventDragSelect',
                'onBeforeEventDropFinalize',
                'onBeforeEventEdit',
                'onBeforeEventEditShow',
                'onBeforeEventResize',
                'onBeforeEventResizeFinalize',
                'onBeforeEventSave',
                'onBeforeEventSelectionChange',
                'onBeforeExcelExport',
                'onBeforeFillHandleDragStart',
                'onBeforeFinishCellEdit',
                'onBeforeFinishRowEdit',
                'onBeforeHide',
                'onBeforePan',
                'onBeforePaste',
                'onBeforePdfExport',
                'onBeforePresetChange',
                'onBeforeRenderRow',
                'onBeforeRenderRows',
                'onBeforeRowCollapse',
                'onBeforeRowExpand',
                'onBeforeSelectionChange',
                'onBeforeSetRecord',
                'onBeforeShow',
                'onBeforeShowTerminals',
                'onBeforeStartRowEdit',
                'onBeforeStateApply',
                'onBeforeStateSave',
                'onBeforeToggleGroup',
                'onBeforeToggleNode',
                'onCancelCellEdit',
                'onCatchAll',
                'onCellClick',
                'onCellContextMenu',
                'onCellDblClick',
                'onCellMenuBeforeShow',
                'onCellMenuItem',
                'onCellMenuShow',
                'onCellMenuToggleItem',
                'onCellMouseEnter',
                'onCellMouseLeave',
                'onCellMouseOut',
                'onCellMouseOver',
                'onCollapse',
                'onCollapseNode',
                'onColumnDrag',
                'onColumnDragStart',
                'onColumnDrop',
                'onColumnResize',
                'onColumnResizeStart',
                'onContextMenuItem',
                'onContextMenuToggleItem',
                'onCopy',
                'onCurrentTimelineUpdate',
                'onDataChange',
                'onDateRangeChange',
                'onDependenciesDrawn',
                'onDependencyClick',
                'onDependencyContextMenu',
                'onDependencyCreateDragStart',
                'onDependencyCreateDrop',
                'onDependencyDblClick',
                'onDependencyMenuBeforeShow',
                'onDependencyMenuItem',
                'onDependencyMenuShow',
                'onDependencyMouseOut',
                'onDependencyMouseOver',
                'onDependencyValidationComplete',
                'onDependencyValidationStart',
                'onDestroy',
                'onDirtyStateChange',
                'onDragCreateEnd',
                'onDragCreateStart',
                'onDragSelecting',
                'onEventAutoCreated',
                'onEventClick',
                'onEventContextMenu',
                'onEventDblClick',
                'onEventDrag',
                'onEventDragAbort',
                'onEventDragModeChange',
                'onEventDragReset',
                'onEventDragSelect',
                'onEventDragStart',
                'onEventDrop',
                'onEventEditBeforeSetRecord',
                'onEventKeyDown',
                'onEventKeyUp',
                'onEventMenuBeforeShow',
                'onEventMenuItem',
                'onEventMenuShow',
                'onEventMouseDown',
                'onEventMouseEnter',
                'onEventMouseLeave',
                'onEventMouseOut',
                'onEventMouseOver',
                'onEventMouseUp',
                'onEventPartialResize',
                'onEventResizeEnd',
                'onEventResizeStart',
                'onEventSelectionChange',
                'onExpand',
                'onExpandNode',
                'onFileDrop',
                'onFillHandleBeforeDragFinalize',
                'onFillHandleDrag',
                'onFillHandleDragAbort',
                'onFillHandleDragEnd',
                'onFillHandleDragStart',
                'onFinishCellEdit',
                'onFinishRowEdit',
                'onFocusIn',
                'onFocusOut',
                'onGridRowBeforeDragStart',
                'onGridRowBeforeDropFinalize',
                'onGridRowDrag',
                'onGridRowDragAbort',
                'onGridRowDragStart',
                'onGridRowDrop',
                'onHeaderClick',
                'onHeaderMenuBeforeShow',
                'onHeaderMenuItem',
                'onHeaderMenuShow',
                'onHeaderMenuToggleItem',
                'onHide',
                'onLockRows',
                'onMouseOut',
                'onMouseOver',
                'onNavigate',
                'onPaint',
                'onPaste',
                'onPasteNotAllowed',
                'onPdfExport',
                'onPresetChange',
                'onReadOnly',
                'onRecompose',
                'onReleaseEvent',
                'onRenderEvent',
                'onRenderRow',
                'onRenderRows',
                'onResize',
                'onResourceHeaderClick',
                'onResourceHeaderContextmenu',
                'onResourceHeaderDblclick',
                'onResourceMenuBeforeShow',
                'onResourceMenuItem',
                'onResourceMenuShow',
                'onResourceMenuToggleItem',
                'onResourceTimeRangeClick',
                'onResourceTimeRangeContextMenu',
                'onResourceTimeRangeDblClick',
                'onResourceTimeRangeMouseDown',
                'onResourceTimeRangeMouseOut',
                'onResourceTimeRangeMouseOver',
                'onResourceTimeRangeMouseUp',
                'onResponsive',
                'onRowCollapse',
                'onRowExpand',
                'onRowMouseEnter',
                'onRowMouseLeave',
                'onScheduleClick',
                'onScheduleContextMenu',
                'onScheduleDblClick',
                'onScheduleMenuBeforeShow',
                'onScheduleMenuItem',
                'onScheduleMenuShow',
                'onScheduleMouseDown',
                'onScheduleMouseEnter',
                'onScheduleMouseLeave',
                'onScheduleMouseMove',
                'onScheduleMouseUp',
                'onScroll',
                'onScrollButtonClick',
                'onSelectionChange',
                'onSelectionModeChange',
                'onShiftIncrementChange',
                'onShow',
                'onSplit',
                'onSplitterCollapseClick',
                'onSplitterDragEnd',
                'onSplitterDragStart',
                'onSplitterExpandClick',
                'onStartCellEdit',
                'onStartRowEdit',
                'onSubGridCollapse',
                'onSubGridExpand',
                'onTickCellClick',
                'onTickCellContextMenu',
                'onTickCellDblClick',
                'onTickCellMouseDown',
                'onTickCellMouseUp',
                'onTickSizeChange',
                'onTimeAxisChange',
                'onTimeAxisHeaderClick',
                'onTimeAxisHeaderContextMenu',
                'onTimeAxisHeaderDblClick',
                'onTimeAxisHeaderMenuBeforeShow',
                'onTimeAxisHeaderMenuItem',
                'onTimeAxisHeaderMenuShow',
                'onTimelineContextChange',
                'onTimelineViewportResize',
                'onTimeRangeHeaderClick',
                'onTimeRangeHeaderContextMenu',
                'onTimeRangeHeaderDblClick',
                'onTimeSelectionChange',
                'onTimeSelectionElementClick',
                'onToggleGroup',
                'onToggleNode',
                'onToolClick',
                'onUnlockRows',
                'onUnsplit',
                'onVisibleDateRangeChange',
                'overlappingEventSorter',
                'preserveScroll',
                'presets',
                'project',
                'range',
                'readOnly',
                'recurrenceConfirmationPopup',
                'resourceMargin',
                'resources',
                'resourceStore',
                'resourceTimeRanges',
                'resourceTimeRangeStore',
                'rowHeight',
                'rowLines',
                'rtl',
                'scrollable',
                'selectionMode',
                'selectResourceOnEventNavigate',
                'selectResourceOnScheduleClick',
                'shiftIncrement',
                'showTooltip',
                'snap',
                'startDate',
                'stateSettings',
                'store',
                'suppressFit',
                'terminalHideDelay',
                'terminalOffset',
                'terminalShowDelay',
                'terminalSize',
                'tickSize',
                'timeRanges',
                'timeRangeStore',
                'timeResolution',
                'timeZone',
                'title',
                'tools',
                'tooltipTemplate',
                'transitionDuration',
                'updateTimelineContextOnScroll',
                'useContextualRecurrenceRules',
                'useInitialAnimation',
                'viewPreset',
                'visibleDate',
                'width',
                'workingTime'
            ],

            propertyNames : [
                'focusVisible',
                'hasChanges',
                'isEngineReady',
                'originalStore',
                'parent',
                'scrollLeft',
                'scrollTop',
                'scrollX',
                'selectedAssignments',
                'selectedCell',
                'selectedCells',
                'selectedEvents',
                'selectedRecord',
                'selectedRecords',
                'selectedRows',
                'state',
                'tooltip',
                'zoomLevel'
            ],

            eventNames : [
                'afterDependencyCreateDrop',
                'afterDependencySave',
                'afterDragCreate',
                'afterEventDragSelect',
                'afterEventDrop',
                'afterEventEdit',
                'afterEventSave',
                'assignmentSelectionChange',
                'beforeAssignmentDelete',
                'beforeAssignmentSelectionChange',
                'beforeAutoCreate',
                'beforeCancelCellEdit',
                'beforeCancelRowEdit',
                'beforeCellDelete',
                'beforeCellEditStart',
                'beforeColumnDragStart',
                'beforeColumnDropFinalize',
                'beforeColumnResize',
                'beforeCopy',
                'beforeCSVExport',
                'beforeDependencyAdd',
                'beforeDependencyCreateDrag',
                'beforeDependencyCreateFinalize',
                'beforeDependencyDelete',
                'beforeDependencyEdit',
                'beforeDependencyEditShow',
                'beforeDependencySave',
                'beforeDestroy',
                'beforeDragCreate',
                'beforeDragCreateFinalize',
                'beforeEventAdd',
                'beforeEventDelete',
                'beforeEventDrag',
                'beforeEventDragSelect',
                'beforeEventDropFinalize',
                'beforeEventEdit',
                'beforeEventEditShow',
                'beforeEventResize',
                'beforeEventResizeFinalize',
                'beforeEventSave',
                'beforeEventSelectionChange',
                'beforeExcelExport',
                'beforeFillHandleDragStart',
                'beforeFinishCellEdit',
                'beforeFinishRowEdit',
                'beforeHide',
                'beforePan',
                'beforePaste',
                'beforePdfExport',
                'beforePresetChange',
                'beforeRenderRow',
                'beforeRenderRows',
                'beforeRowCollapse',
                'beforeRowExpand',
                'beforeSelectionChange',
                'beforeSetRecord',
                'beforeShow',
                'beforeShowTerminals',
                'beforeStartRowEdit',
                'beforeStateApply',
                'beforeStateSave',
                'beforeToggleGroup',
                'beforeToggleNode',
                'cancelCellEdit',
                'catchAll',
                'cellClick',
                'cellContextMenu',
                'cellDblClick',
                'cellMenuBeforeShow',
                'cellMenuItem',
                'cellMenuShow',
                'cellMenuToggleItem',
                'cellMouseEnter',
                'cellMouseLeave',
                'cellMouseOut',
                'cellMouseOver',
                'collapse',
                'collapseNode',
                'columnDrag',
                'columnDragStart',
                'columnDrop',
                'columnResize',
                'columnResizeStart',
                'contextMenuItem',
                'contextMenuToggleItem',
                'copy',
                'currentTimelineUpdate',
                'dataChange',
                'dateRangeChange',
                'dependenciesDrawn',
                'dependencyClick',
                'dependencyContextMenu',
                'dependencyCreateDragStart',
                'dependencyCreateDrop',
                'dependencyDblClick',
                'dependencyMenuBeforeShow',
                'dependencyMenuItem',
                'dependencyMenuShow',
                'dependencyMouseOut',
                'dependencyMouseOver',
                'dependencyValidationComplete',
                'dependencyValidationStart',
                'destroy',
                'dirtyStateChange',
                'dragCreateEnd',
                'dragCreateStart',
                'dragSelecting',
                'eventAutoCreated',
                'eventClick',
                'eventContextMenu',
                'eventDblClick',
                'eventDrag',
                'eventDragAbort',
                'eventDragModeChange',
                'eventDragReset',
                'eventDragSelect',
                'eventDragStart',
                'eventDrop',
                'eventEditBeforeSetRecord',
                'eventKeyDown',
                'eventKeyUp',
                'eventMenuBeforeShow',
                'eventMenuItem',
                'eventMenuShow',
                'eventMouseDown',
                'eventMouseEnter',
                'eventMouseLeave',
                'eventMouseOut',
                'eventMouseOver',
                'eventMouseUp',
                'eventPartialResize',
                'eventResizeEnd',
                'eventResizeStart',
                'eventSelectionChange',
                'expand',
                'expandNode',
                'fileDrop',
                'fillHandleBeforeDragFinalize',
                'fillHandleDrag',
                'fillHandleDragAbort',
                'fillHandleDragEnd',
                'fillHandleDragStart',
                'finishCellEdit',
                'finishRowEdit',
                'focusIn',
                'focusOut',
                'gridRowBeforeDragStart',
                'gridRowBeforeDropFinalize',
                'gridRowDrag',
                'gridRowDragAbort',
                'gridRowDragStart',
                'gridRowDrop',
                'headerClick',
                'headerMenuBeforeShow',
                'headerMenuItem',
                'headerMenuShow',
                'headerMenuToggleItem',
                'hide',
                'lockRows',
                'mouseOut',
                'mouseOver',
                'navigate',
                'paint',
                'paste',
                'pasteNotAllowed',
                'pdfExport',
                'presetChange',
                'readOnly',
                'recompose',
                'releaseEvent',
                'renderEvent',
                'renderRow',
                'renderRows',
                'resize',
                'resourceHeaderClick',
                'resourceHeaderContextmenu',
                'resourceHeaderDblclick',
                'resourceMenuBeforeShow',
                'resourceMenuItem',
                'resourceMenuShow',
                'resourceMenuToggleItem',
                'resourceTimeRangeClick',
                'resourceTimeRangeContextMenu',
                'resourceTimeRangeDblClick',
                'resourceTimeRangeMouseDown',
                'resourceTimeRangeMouseOut',
                'resourceTimeRangeMouseOver',
                'resourceTimeRangeMouseUp',
                'responsive',
                'rowCollapse',
                'rowExpand',
                'rowMouseEnter',
                'rowMouseLeave',
                'scheduleClick',
                'scheduleContextMenu',
                'scheduleDblClick',
                'scheduleMenuBeforeShow',
                'scheduleMenuItem',
                'scheduleMenuShow',
                'scheduleMouseDown',
                'scheduleMouseEnter',
                'scheduleMouseLeave',
                'scheduleMouseMove',
                'scheduleMouseUp',
                'scroll',
                'scrollButtonClick',
                'selectionChange',
                'selectionModeChange',
                'shiftIncrementChange',
                'show',
                'split',
                'splitterCollapseClick',
                'splitterDragEnd',
                'splitterDragStart',
                'splitterExpandClick',
                'startCellEdit',
                'startRowEdit',
                'subGridCollapse',
                'subGridExpand',
                'tickCellClick',
                'tickCellContextMenu',
                'tickCellDblClick',
                'tickCellMouseDown',
                'tickCellMouseUp',
                'tickSizeChange',
                'timeAxisChange',
                'timeAxisHeaderClick',
                'timeAxisHeaderContextMenu',
                'timeAxisHeaderDblClick',
                'timeAxisHeaderMenuBeforeShow',
                'timeAxisHeaderMenuItem',
                'timeAxisHeaderMenuShow',
                'timelineContextChange',
                'timelineViewportResize',
                'timeRangeHeaderClick',
                'timeRangeHeaderContextMenu',
                'timeRangeHeaderDblClick',
                'timeSelectionChange',
                'timeSelectionElementClick',
                'toggleGroup',
                'toggleNode',
                'toolClick',
                'unlockRows',
                'unsplit',
                'visibleDateRangeChange'
            ]
        };
    },

    /**
     * Called after the instance has been mounted
     */
    mounted() {
        const
            me = this,
            {
                createWidget,
                relayStores,
                watchProps,
                processCellContent,
                processEventContent,
                hasFrameworkRenderer
            }  = WrapperHelper();

        me.instance = createWidget({
            me,
            props                : me.$props,
            data                 : me.$data,
            listeners            : me.$listeners,
            emit                 : me.$emit.bind(me),
            element              : me.$el,
            processCellContent   : processCellContent.bind(me),
            processEventContent  : processEventContent.bind(me),
            hasFrameworkRenderer : hasFrameworkRenderer.bind(me)
        });
        // Backwards compatibility for gridInstance, schedulerInstance etc.
        me[StringHelper.uncapitalize(me.instanceClass.$name) + 'Instance'] = me.instance;
        relayStores(me.$data, me.instance);

        const watcher = me.$watch.bind(me);
        watchProps(me, me.instance, me.$props, me.$data, watcher);
    },

    /**
     * Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
     */
    beforeDestroy() {
        if (this.instance) {
            this.instance.destroy();
        }
    }

};

</script>
